module.exports = __webpack_public_path__ + "img/VetoSansCond-Italic_1.fb48fbec.svg";